import React from 'react';

const AVATAR_BASE = 'https://ultimatewebscraper.com/assets/images/avatars';
const AVATARS = [
  `${AVATAR_BASE}/avatar5.jpg`,
  `${AVATAR_BASE}/avatar2.jpg`,
  `${AVATAR_BASE}/avatar1.jpg`,
  `${AVATAR_BASE}/avatar4.jpg`,
  `${AVATAR_BASE}/avatar3.jpg`,
];

const HeroSection = ({ subtitle = 'Supercharge your data collection. More credits, more cloud browsers, faster results.' }) => (
  <div className="text-center pt-8 pb-2">
    <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 dark:text-gray-100 mb-4 tracking-tight leading-tight">
      Unlock the{' '}
      <span className="bg-gradient-to-r from-blue-500 via-cyan-500 to-purple-500 bg-clip-text text-transparent">
        Cloud Platform
      </span>
    </h1>

    <p className="text-base md:text-lg text-gray-500 dark:text-gray-400 mb-8 max-w-2xl mx-auto leading-relaxed">
      {subtitle}
    </p>

    {/* Social Proof */}
    <div className="flex items-center justify-center gap-4">
      <div className="flex -space-x-2.5">
        {AVATARS.map((src, i) => (
          <img
            key={i}
            src={src}
            alt=""
            className="w-8 h-8 rounded-full border-2 border-white dark:border-gray-900 object-cover bg-gray-200 dark:bg-gray-700 shadow-sm"
          />
        ))}
      </div>
      <div className="flex items-center gap-x-3 text-sm text-gray-500 dark:text-gray-400">
        <span><span className="font-bold text-gray-800 dark:text-gray-100">80,000+</span> professionals</span>
        <span className="text-gray-300 dark:text-gray-600">|</span>
        <span><span className="font-bold text-gray-800 dark:text-gray-100">10M+</span> pages collected</span>
        <span className="text-gray-300 dark:text-gray-600">|</span>
        <span><span className="font-bold text-gray-800 dark:text-gray-100">4.8/5</span> Chrome Store</span>
      </div>
    </div>
  </div>
);

export default HeroSection;
